import {makeAutoObservable} from "mobx";

export default class AddStore {
    constructor() {
        this._bedrooms = []
        this._buildings = []
        this._floors = []
        this._rooms = []
        this._repairs = []
        this._heatings = []
        this._parkings = []
        this._areas = []
        this._rules = [
            { id: 1, value: 'Можно с животными' },
            { id: 2, value: 'Можно с детьми' },
            { id: 3, value: 'Можно курить' },
        ]
        this._adds = []
        this._mapAdds = []
        this._blogs = []
        this._places = []
        this._page = 1
        this._totalCount = 0
        this._limit = 20

        this._reviews = []

        this._selectedBuilding = {}
        this._selectedBedroom = {}
        this._selectedFloor = {}
        this._selectedRoom = {}
        this._selectedRepair = {}
        this._selectedHeating = {}
        this._selectedParking = {}
        this._selectedArea = {}
        this._selectedInfo = {}
        this._selectedAnimal = {}
        this._selectedChildren = {}
        this._selectedSmoking = {}

        this._catalogScrollY = 0
        this._shouldRestoreCatalog = false

        this._mapSearchState = null
        this._shouldRestoreMapSearch = false

        makeAutoObservable(this)
    }

    //////////////////////////////////SET ANYTHING////////////////////////////////////////////////

    setBedrooms(bedrooms) {
        this._bedrooms = bedrooms
    }

    setBuildings(buildings) {
        this._buildings = buildings
    }

    setAreas(areas) {
        this._areas = areas
    }

    setFloors(floors) {
        this._floors = floors
    }

    setReviews(reviews) {
        this._reviews = reviews
    }

    setRooms(rooms) {
        this._rooms = rooms
    }

    setRepairs(repairs) {
        this._repairs = repairs
    }

    setHeatings(heatings) {
        this._heatings = heatings
    }

    setParkings(parkings) {
        this._parkings = parkings
    }

    setAdds(adds) {
        this._adds = adds
    }

    setMapAdds(adds) {
        this._mapAdds = adds
    }

    setBlogs(blogs){
        this._blogs = blogs
    }

    setPlaces(places){
        this._places = places
    }

    setPage(page) {
        this._page = page
    }

    setCatalogScrollY(value) {
        this._catalogScrollY = value
    }

    setShouldRestoreCatalog(value) {
        this._shouldRestoreCatalog = value
    }

    setMapSearchState(state) {
        this._mapSearchState = state
    }

    setShouldRestoreMapSearch(value) {
        this._shouldRestoreMapSearch = value
    }

    //////////////////////////////////SET SELECTED////////////////////////////////////////////////

    setSelectedBuilding(building) {
        this._selectedBuilding = building
    }

    setSelectedBedroom(bedroom) {
        this._selectedBedroom = bedroom
    }

    setSelectedFloor(floor) {
        this._selectedFloor = floor
    }
    setSelectedRoom(room) {
        this._selectedRoom = room
    }

    setSelectedRepair(repair) {
        this._selectedRepair = repair
    }

    setSelectedHeating(heating) {
        this._selectedHeating = heating
    }

    setSelectedParking(parking) {
        this._selectedParking = parking
    }

    setSelectedArea(area) {
        this._selectedArea = area
    }

    setTotalCount(count) {
        this._totalCount = count
    }

    //////////////////////////////////SET LOGIC////////////////////////////////////////////////

    get bedrooms() {
        return this._bedrooms
    }

    get buildings() {
        return this._buildings
    }

    get areas() {
        return this._areas
    }

    get floors() {
        return this._floors
    }

    get reviews() {
        return this._reviews
    }

    get rooms() {
        return this._rooms
    }

    get repairs() {
        return this._repairs
    }

    get heatings() {
        return this._heatings
    }

    get parkings() {
        return this._parkings
    }

    get adds() {
        return this._adds
    }

    get mapAdds() {
        return this._mapAdds
    }

    get blogs() {
        return this._blogs
    }

    get places() {
        return this._places
    }

    get catalogScrollY() {
        return this._catalogScrollY
    }

    get shouldRestoreCatalog() {
        return this._shouldRestoreCatalog
    }

    get mapSearchState() {
        return this._mapSearchState
    }

    get shouldRestoreMapSearch() {
        return this._shouldRestoreMapSearch
    }

    //
    get selectedBuilding() {
        return this._selectedBuilding
    }

    get selectedBedroom() {
        return this._selectedBedroom
    }

    get selectedFloor() {
        return this._selectedFloor
    }

    get selectedRoom() {
        return this._selectedRoom
    }

    get selectedRepair() {
        return this._selectedRepair
    }

    get selectedHeating() {
        return this._selectedHeating
    }

    get selectedParking() {
        return this._selectedParking
    }

    get selectedAnimal(){
        return this._selectedAnimal
    }

    get selectedChildren(){
        return this._selectedChildren
    }

    get selectedSmoking(){
        return this._selectedSmoking
    }

    get selectedInfo() {
        return this._selectedInfo
    }

    get selectedArea() {
        return this._selectedArea
    }

    get totalCount() {
        return this._totalCount
    }

    get page() {
        return this._page
    }

    get limit() {
        return this._limit
    }
}